module.exports = __webpack_public_path__ + "314228164848bea74e29d5bfbe6ffeb4.svg";